import { Row, Col, Form, Table } from "react-bootstrap";
import {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect,
  useRef
} from "react";
import { isAlphanumericAllSpecialCharacters, SquareBracketNotAllowed, isAlphanumericAllSpecialCharactersPlusMinusDegree, isAlphanumericAllSpecialCharactersAmpersand, isAlphanumericAllSpecialCharactersDashPlusMinusDegree, isAlphanumericWithDashSlashPlus, isAlphanumericWithDiameterDashSlash, isAllowDashedSpecialCharactersPlusMinusPercentAmpersand, isAlphanumericMinusPlusPercent, isAlphanumericWithDashSlashPlusAmpersand, isAlphanumericAllSpecialCharactersDashPlusMinus } from "../../functions/validations";
import { PQRPage3TableColumnN } from "../utility/common/TransactionComponents/WPQ_PQR_Test_Table_Components";
import { validatePQRForm } from "./PQRObjects/PQR_ValidationConfig";
import { pqrJointType, PQR_tubesheet_pg1_array, Company_Name } from "./PQRObjects/PQR_entity";
import { Action, Status, MessageTypes } from "../utility/common/constants/CommonConstants";
import { getbyprojectno } from "../../Services/pqr-header-service";
import { AddNewDetail } from "../../Services/pqr-details-service";
import { getPNOActive } from "../../Services/pcategory-service";
import { getActiveAno } from "../../Services/ano-services";
import { getActiveSfa } from "../../Services/sfa-service";
import { getActiveFno } from "../../Services/fno-services";
import { checkPQRTubeProcessAdded, AddUpdatePQRHeader } from "./PQRObjects/PQR_Validations";
import { emptyError } from "./PQRObjects/PQR_common";
import { createPQRTestDataObjects, handlePQRGeneralSubmit, handlePQRGeneralSubmitTemp } from "../utility/common/TransactionComponents/TransactionSubmitUtils";
import { SingleInput, General_Single_Input_select, SingleInputTextAreaNotes } from "../utility/forms/inputs/InputsTransaction"
import { PQR_TTS_Process_Grid_Input, PQR_TTS_Process_Grid_Input_2, PQR_Process_Grid_InputProcess, PQRProcessGridInput2 } from "./PQRObjects/PQR_Grid_Tubesheet";
import { getPresignedURL } from "../../Services/Welder-services";
import { BaseMetalTable_PQRTube } from "./PQRObjects/BaseMetalTablePQR";
import { PQR_Filler_metals } from "./PQRObjects/PQR_Filler_metals";
import axios from "axios";
import { DateInput } from "../utility/common/helpers/DateComponent";
import { createCommonFetchUtilities, handleChangeNotesFlexible } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { fetchImagePreview, ImageArray3, validateFile } from "../utility/common/TransactionComponents/CommonImages";
import { WPQ_PQR_Process_Grid_Input2_tube } from "../utility/common/TransactionComponents/Common_WPS_WPQ_PQR_Process_Input_Fields";
import { maxDate, todayDate } from "../utility/common/helpers/TodayDate";
import { DotLoader } from "react-spinners";
import { PlantLocation } from "../utility/common/TransactionComponents/TransactionEntity";

const PQRTubesheetPage1 = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      setdetailObj,
      errorstyle,
      blyestyle,
      WPStype,
      isDisabled,
      isReadonly,
      copydata,
      action,
      setaction,
      setIsDisabled
    },
    ref
  ) => {
    let username = sessionStorage.getItem("UserName");
    let folderPQR = "PQR_Tubesheet";
    const [PNoActive, setPNoActive] = useState([]);
    const [isEdited, setIsEdited] = useState(false);
    const [SfaActive, setSfaActive] = useState([]);
    const [FnoActive, setFnoActive] = useState([]);
    const [AnoActive, setAnoActive] = useState([]);
    const [chemicalAnaError, setChemicalAnaError] = useState([]);
    const [checkwpsdata] = useState([]);
    const [classError, setClassError] = useState([]);
    const [Readonly] = useState("");
    const [valueNotes, setValueNotes] = useState("");
    let isoverlay = WPStype === "Groove" ? false : true;
    let grooveclass = WPStype === "Groove" ? "row-margin" : "d-none";
    let overclass = WPStype !== "Groove" ? "row-margin" : "d-none";

    const [isOverlay, setOverlay] = useState(isoverlay);
    const [Grooveclass, setoverlayclass] = useState(grooveclass);
    const [overlaytext] = useState(overclass);

    const [profile, setProfile] = useState("");
    const [profile1, setProfile1] = useState("");
    const [profile2, setProfile2] = useState("");

    const [previewUrl1, setPreviewUrl1] = useState();
    const [previewUrl2, setPreviewUrl2] = useState();
    const [previewUrl3, setPreviewUrl3] = useState();

    const TubesheetFileMappings = [
      {
        setImage: setProfile,
        previewFn: previewUrl1,
        headerPath: () => headerObj.Pdf_images && headerObj.Pdf_images[0]?.tube_Hole_ligament || "",
        imageKey: headerObj.Pdf_images && headerObj.Pdf_images[0]?.tube_Hole_ligament || "",
        setPreviewFn: setPreviewUrl1,
        profile: profile
      },
      {
        setImage: setProfile1,
        previewFn: previewUrl2,
        headerPath: () => headerObj.Pdf_images && headerObj.Pdf_images[1]?.tube_Hole || "",
        imageKey: headerObj.Pdf_images && headerObj.Pdf_images[1]?.tube_Hole || "",
        setPreviewFn: setPreviewUrl2,
        profile: profile1
      },
      {
        setImage: setProfile2,
        previewFn: previewUrl3,
        headerPath: () => headerObj.Pdf_images[2] && headerObj.Pdf_images[2]?.tube_Weld_Joint || "",
        imageKey: headerObj.Pdf_images && headerObj.Pdf_images[2]?.tube_Weld_Joint || "",
        setPreviewFn: setPreviewUrl3,
        profile: profile2
      },
    ]

    const [loading, setLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const [fieldPWHT, setFieldPWHT] = useState(false);
    const [Certification_Disabled, setCertification_Disabled] = useState(false);
    
    let Certification = headerObj?.Certification || [
      {
        PQR_Certification_Welder_Name: "",
        PQR_Certification_ID: "",
        PQR_Certification_Process: "",
        error: false,
        errormessage: ""
      },
      {
        PQR_Certification_Welder_Name: "",
        PQR_Certification_ID: "",
        PQR_Certification_Process: "",
        error: false,
        errormessage: ""
      },
      {
        PQR_Certification_Welder_Name: "",
        PQR_Certification_ID: "",
        PQR_Certification_Process: "",
        error: false,
        errormessage: ""
      },
      {
        PQR_Certification_Welder_Name: "",
        PQR_Certification_ID: "",
        PQR_Certification_Process: "",
        error: false,
        errormessage: ""
      }
    ];
    let CertificationLabRef = headerObj?.CertificationLabRef || [
      {
        PQR_Certification_Lab_RefNo: "",
        error: false,
        errormessage: ""
      },
      {
        PQR_Certification_Lab_RefNo: "",
        error: false,
        errormessage: ""
      }
    ];
    let sessionName = "PQRTubesheet";

    // Initialize arrays in headerObj if they don't exist
    if (!headerObj?.Certification) {
      setheaderObj(prev => ({
        ...prev,
        Certification: Certification
      }));
    }
    if (!headerObj?.CertificationLabRef) {
      setheaderObj(prev => ({
        ...prev,
        CertificationLabRef: CertificationLabRef
      }));
    }
    const [error, setError] = useState({
      PQR_RecordNo: {},
      PQR_Date: {},
      PQR_Qualificationcode: {},
      PQR_pWPSNo: {},
      PQR_WPS_ReviNo: {},
      PQR_LastUpdate_Date: {},
      PQR_Last_UpdatedBy: {},
      PQR_Last_WeldDate: {},
      PQR_Address: {},

      PQR_BM_BM_ProductForm: {},
      PQR_BM_BM_Spec: {},
      PQR_BM_BM_Pno: {},
      PQR_BM_BM_Gno: {},
      PQR_BM_BM_Thk: {},
      PQR_BM_BM_Dia: {},

      PQR_BM_WTBM_ProductForm: {},
      PQR_BM_WTBM_Spec: {},
      PQR_BM_WTBM_Pno: {},
      PQR_BM_WTBM_Gno: {},
      PQR_BM_WTBM_Thk: {},
      PQR_BM_WTBM_Dia: {},

      PQR_JD_JointType: {},
      PQR_JD_TubePitch: {},
      PQR_JD_TubeProj: {},
      PQR_JD_Pattern: {},
      PQR_JD_GrooveAngle: {},
      PQR_JD_HoleId: {},
      PQR_JD_GrooveDepth: {},
      PQR_JD_WidthLigament: {},

      PQRD_WP_LayerNo: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_FillerMetalSize: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_Amperes: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_DC_Pulsing_current: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_DC_Pulsing_current_Others: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_Volatage_Volts: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_Travel_Speed: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_Heat_Input: [{ Value_A: [""] }, { Value_B: [""] }, { Value_C: [""] }],
      PQRD_WP_PolarityOrCurrent: [{ Value_A: [""] }, { Value_B: [""] }],

      PQR_JD_Notes: {},
      wld_pdf_image: {},
      PQR_Image_Notes: {},

      PQR_Process: {},
      WPSD_FM_SFA: {},
      WPSD_FM_Classification: {},
      WPSD_FM_FNo: {},
      WPSD_FM_Ano: {},
      WPSD_FM_ChemicalAnalysis_TradeName: {},

      PQRD_WP_MinimumPreheatTemp: {},
      PQRD_WP_MaximumInterpassTemp: {},
      PQRD_WP_PostHeating: {},
      PQRD_WP_TungstenType: {},
      PQRD_WP_WeldPosition: {},
      PQRD_WP_WeldProgression: {},
      PQRD_WP_NoofPasses: {},

      PQRD_WP_ArcVoltageControl: {},
      PQRD_WP_ShieldingGasType: {},
      PQRD_WP_ShieldingFlowRate: {},
      PQRD_WP_Auxiliarygas: {},
      PQRD_WP_Expansion: {},
      PQRD_WP_MethodofCleaning: {},
      PQRD_WP_SingleMultiElectrode: {},
      PQRD_WP_Peening: {},
      PQRD_WP_ThermalProcess: {},
      PQRD_WP_StringWeave: {},
      PQRD_WP_Oscillation: {},
      PQRD_WP_OrificeCupSize: {},
      PQRD_WP_ClosedOutChamber: {},

      PQR_PWHeatTre_Temperature: {},
      PQR_PWHeatTre_Time: {},
      PQR_PWHeatTre_Type: {},
      PQR_PWHeatTre_Heating_Rate: {},
      PQR_PWHeatTre_Cooling_Rate: {},
      PQR_PWHeatTre_Notes: {},

      PQR_Certification_Welder_Name: {},
      PQR_Certification_ID: {},
      PQR_Certification_Process: {},
      PQR_Certification_ConductedBy: {},
      PQR_Certification_Lab_RefNo: {},
      PQR_FM_PreFillerMetal: {},
      PQR_FM_WithFillerMetal: {},
      PQR_FM_FillerProduct: {},
      PQR_FM_Inserts: {},
      PQR_FM_FillerFlux: {},
      PQR_FM_FillerOthers: {},
    });

    const dependentFields = ["PQRD_WP_Heat_Input", "PQRD_WP_Travel_Speed",
      "PQRD_WP_Volatage_Volts", "PQRD_WP_Amperes",
      "PQRD_WP_DC_Pulsing_current", "PQRD_WP_DC_Pulsing_current_Others"
    ];

    const resetFields = (obj, index, valueField) => {
      console.log(obj, index, valueField, "args");
      dependentFields.forEach((field) => {
          obj[field][index][valueField][0] = "";
      })
    };

    const handle_2Input_ChangeA = (key, id, valueIndex, newValue) => {
      const updatedProcessObj = { ...detailObj };
      if (!updatedProcessObj[key]?.[id]?.Value_A) return;
      updatedProcessObj[key][id].Value_A[valueIndex] = newValue;
      if (key == "PQRD_WP_FillerMetalSize" && newValue == "") {
        resetFields(updatedProcessObj, 0, "Value_A");
      }
      setdetailObj(updatedProcessObj);
    };

    const handle_2Input_ChangeB = (key, id, valueIndex, newValue) => {
      const updatedProcessObj = { ...detailObj };
      if (!updatedProcessObj[key]?.[id]?.Value_B) return;
      updatedProcessObj[key][id].Value_B[valueIndex] = newValue;
      if (key == "PQRD_WP_FillerMetalSize" && newValue == "") {
        resetFields(updatedProcessObj, 1, "Value_B");
      }
      setdetailObj(updatedProcessObj);
    };

    const handle_2Input_ChangeC = (key, id, valueIndex, newValue) => {
      const updatedProcessObj = { ...detailObj };
      if (!updatedProcessObj[key]?.[id]?.Value_C) return;
      updatedProcessObj[key][id].Value_C[valueIndex] = newValue;
      if (key == "PQRD_WP_FillerMetalSize" && newValue == "") {
        resetFields(updatedProcessObj, 2, "Value_C");
      }
      setdetailObj(updatedProcessObj);
    };

    const handleChange = (e) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const { name, value } = e.target;
      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const handleChangeNotes = (e) => {
      handleChangeNotesFlexible(e, {
        setIsEdited,
        setStateObj: setheaderObj,
        setValueNotes,
        maxNewLines: 3,
        maxLineLength: 100,
        actionCheck: () => {
          if (action === Action.ActionEdit) setIsEdited(true);
        }
      });
    };

    const validate = async () => {
      // Use unified validation for tubesheet page 1
      const validationResult = validatePQRForm({
        headerObj,
        detailObj,
        WPStype,
        currentErrors: error,
        pageType: "tubesheet1",
        setError,
      });

      let isError = validationResult.isError;

      // Duplicate check
      if ((action === Action.ActionCopy || action === Action.ActionAdd) && !isError) {
        if (await checkDuplicate(WPStype, headerObj.Wld_createdon_year, headerObj.PQR_RecordNo)) {
          isError = true;
          setError((prevState) => ({
            ...prevState,
            PQR_RecordNo: {
              status: true,
              message: "PQR Record No. already exists",
            },
          }));
        }
      }

      // Process validation
      let norows = checkPQRTubeProcessAdded(detailObj);
      if (norows) {
        detailObj.errormessage = "Tubesheet SFA Type and F.No.,A.NO. are required";
        isError = true;
        detailObj.error = true;

        if (
          detailObj.PQR_Process !== "" &&
          detailObj.WPSD_FM_FNo !== "" &&
          detailObj.WPSD_FM_Ano !== "" &&
          detailObj.WPSD_FM_SFA !== ""
        ) {
          detailObj.error = false;
        }
      }

      // Filler metal fields regex validation (check errors set by onInput)
      const fillerMetalFields = [
        "PQR_FM_PreFillerMetal", "PQR_FM_WithFillerMetal", "PQR_FM_FillerProduct",
        "PQR_FM_Inserts", "PQR_FM_FillerFlux", "PQR_FM_FillerOthers"
      ];
      if (fillerMetalFields.some((field) => error[field]?.status === true)) {
        isError = true;
      }

      // Certification array validation - check if at least one complete row exists
      const certificationFields = ["PQR_Certification_Welder_Name", "PQR_Certification_ID", "PQR_Certification_Process"];
      let hasValidCertificationRow = false;
      
      if (headerObj.Certification && headerObj.Certification.length > 0) {
        for (let i = 0; i < headerObj.Certification.length; i++) {
          const row = headerObj.Certification[i];
          const isRowComplete = certificationFields.every(field => 
            row[field] && row[field].trim() !== ""
          );
          if (isRowComplete) {
            hasValidCertificationRow = true;
            break;
          }
        }
      }
      
      if (!hasValidCertificationRow) {
        isError = true;
        // Set error on first row to show validation message
        if (headerObj.Certification && headerObj.Certification[0]) {
          headerObj.Certification[0].error = true;
          headerObj.Certification[0].errormessage = "At least one complete certification row is required";
        }
      } else {
        // Clear error if validation passes
        if (headerObj.Certification && headerObj.Certification[0]) {
          headerObj.Certification[0].error = false;
          headerObj.Certification[0].errormessage = "";
        }
      }

      // Tubesheet array validation
      let errortype = PQR_tubesheet_pg1_array;
      errortype.forEach((cols) => {
        let value = detailObj[cols.Column][0].Value_A[0];
        let value1 = detailObj[cols.Column][1].Value_B[0];
        let msg = "This field is required";

        // For FillerMetalSize: first is mandatory, others optional
        if (cols.Column === "PQRD_WP_FillerMetalSize") {
          if (!value) {
            isError = true;
            setError((prevState) => ({
              ...prevState,
              [cols.Column]: [
                { Value_A: [{ status: true, message: msg }] },
                { Value_B: [{ status: false, message: "" }] },
                { Value_C: [{ status: false, message: "" }] },
              ],
            }));
          }
        } else if (cols.Column === "PQRD_WP_PolarityOrCurrent") {
          if (!value || !value1) {
            isError = true;
            setError((prevState) => ({
              ...prevState,
              [cols.Column]: [
                { Value_A: [{ status: true, message: msg }] },
                { Value_B: [{ status: true, message: msg }] },
              ],
            }));
          }
        } else if (cols.Column === "PQRD_WP_LayerNo") {
          if (!value) {
            isError = true;
            setError((prevState) => ({
              ...prevState,
              [cols.Column]: [
                { Value_A: [{ status: true, message: msg }] },
                { Value_B: [{ status: false, message: "" }] },
                { Value_C: [{ status: false, message: "" }] },
              ],
            }));
          }
        } else {
          // For Amperes to Heat Input: validate only if corresponding filler metal size is filled
          const fillerA = detailObj["PQRD_WP_FillerMetalSize"]?.[0]?.Value_A?.[0] || "";
          const fillerB = detailObj["PQRD_WP_FillerMetalSize"]?.[1]?.Value_B?.[0] || "";
          const fillerC = detailObj["PQRD_WP_FillerMetalSize"]?.[2]?.Value_C?.[0] || "";
          let errorA = fillerA && !value ? { status: true, message: msg } : { status: false, message: "" };
          let errorB = fillerB && !value1 ? { status: true, message: msg } : { status: false, message: "" };
          let valueC = detailObj[cols.Column]?.[2]?.Value_C?.[0] || "";
          let errorC = fillerC && !valueC ? { status: true, message: msg } : { status: false, message: "" };
          if (errorA.status || errorB.status || errorC.status) {
            isError = true;
            setError((prevState) => ({
              ...prevState,
              [cols.Column]: [
                { Value_A: [errorA] },
                { Value_B: [errorB] },
                { Value_C: [errorC] },
              ],
            }));
          }
        }
      });

      return isError;
    };


    const checkDuplicate = async (type, proj, revno) => {
      let reqParam = { groovetype: type, pkid: proj, skid: revno };
      let result = await getbyprojectno(reqParam);
      return (result[0] != undefined);
    };

    const validateTemp = async () => {
      let temperror = emptyError(error, setError, false);
      // Basic validation
      let isError = false;
      if (headerObj?.PQR_RecordNo.trim() === "") {
        isError = true;
        setError((prevState) => ({
          ...prevState,
          PQR_RecordNo: {
            status: true,
            message: "Please enter PQR Record number",
          },
        }));
      }

      // Duplicate check
      if ((action === Action.ActionCopy || action === Action.ActionAdd) && !isError) {
        if (await checkDuplicate(WPStype, headerObj.Wld_createdon_year, headerObj.PQR_RecordNo)) {
          isError = true;
          setError((prevState) => ({
            ...prevState,
            PQR_RecordNo: {
              status: true,
              message: "PQR Record No. already exists",
            },
          }));
        }
      }

      // Process validation
      let norows = checkPQRTubeProcessAdded(detailObj);
      if (norows) {
        detailObj.errormessage = "Tubesheet SFA Type is required";
        isError = true;
        detailObj.error = true;
        setError(prevData => ({
          ...prevData,
          WPSD_FM_SFA: { status: true, message: "Tubesheet SFA Type is required" }
        }));
        if (
          detailObj.PQR_Process !== "" &&
          detailObj.WPSD_FM_FNo !== "" &&
          detailObj.WPSD_FM_Ano !== "" &&
          detailObj.WPSD_FM_SFA !== ""
        ) {
          detailObj.error = false;
        }
      }
      return { isError, temperror };
    };

    const handleCheckboxChange = (e, field, obj) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const isChecked = e.target.checked;
      setheaderObj((header) => ({
        ...header,
        [field]: isChecked ? "Yes" : "No",
      }));
      obj(isChecked);
    };

    const handleChangedetailsarray = (e, i) => {
      const { name, value } = e.target;
      setdetailObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const handleChangeFillerMetal = (e) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const { name, value } = e.target;
      setdetailObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const handleCertificationarray = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.Certification[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);

      setTimeout(() => {
        checkAndUpdateDisabledState('Certification', ["PQR_Certification_Welder_Name", "PQR_Certification_ID", "PQR_Certification_Process"], 1, setCertification_Disabled);
      }, 0);
    };

    const handleCertificationLabRef = (Index, key, newValue) => {
      if (action === Action.ActionEdit) setIsEdited(true);
      const updatedheadertestObj = { ...headerObj };
      updatedheadertestObj.CertificationLabRef[Index][key] = newValue;
      setheaderObj(updatedheadertestObj);
    };

    // Common function to check if max rows are filled and update disabled state
    const checkAndUpdateDisabledState = (arrayName, fieldNames, maxRows, setDisabledFunc) => {
      const array = headerObj[arrayName];
      if (!array || maxRows <= 0) return;

      let filledRows = 0;
      for (let i = 0; i < Math.min(maxRows, array.length); i++) {
        const row = array[i];
        const isRowFilled = fieldNames.every(field => row[field] && row[field].trim() !== '');
        if (isRowFilled) filledRows++;
      }

      setDisabledFunc(filledRows < maxRows);
    };

    const handleAdd = async (approvalstatus) => {
      let result = true;
      let PG1Update = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_Date: headerObj.PQR_Date,
        PQR_Qualificationcode: headerObj.PQR_Qualificationcode,
        PQR_pWPSNo: headerObj.PQR_pWPSNo,
        PQR_WPS_ReviNo: headerObj.PQR_WPS_ReviNo,
        PQR_LastUpdate_Date: headerObj.PQR_LastUpdate_Date,
        PQR_Last_UpdatedBy: headerObj.PQR_Last_UpdatedBy,
        // PQR_MatchStatus: headerObj.PQR_MatchStatus,
        PQR_Last_WeldDate: headerObj.PQR_Last_WeldDate,
        CheckboxPostWHT: headerObj.CheckboxPostWHT,
        PQR_Address: headerObj.PQR_Address,
        PQR_CompanyName: headerObj.PQR_CompanyName,
      };

      let PG1Images = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_Image_Notes: headerObj.PQR_Image_Notes,
        Pdf_images: headerObj?.Pdf_images,
        wld_pdf_image: headerObj?.wld_pdf_image,
      };

      let PG1BM = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_BM_BM_ProductForm: headerObj.PQR_BM_BM_ProductForm,
        PQR_BM_BM_Spec: headerObj.PQR_BM_BM_Spec,
        PQR_BM_BM_Pno: headerObj.PQR_BM_BM_Pno,
        PQR_BM_BM_Gno: headerObj.PQR_BM_BM_Gno,
        PQR_BM_BM_Thk: headerObj.PQR_BM_BM_Thk,
        PQR_BM_BM_Dia: headerObj.PQR_BM_BM_Dia,
        PQR_BM_WTBM_ProductForm: headerObj.PQR_BM_WTBM_ProductForm,
        PQR_BM_WTBM_Spec: headerObj.PQR_BM_WTBM_Spec,
        PQR_BM_WTBM_Pno: headerObj.PQR_BM_WTBM_Pno,
        PQR_BM_WTBM_Gno: headerObj.PQR_BM_WTBM_Gno,
        PQR_BM_WTBM_Thk: headerObj.PQR_BM_WTBM_Thk,
        PQR_BM_WTBM_Dia: headerObj.PQR_BM_WTBM_Dia,
        PQR_FM_PreFillerMetal: headerObj.PQR_FM_PreFillerMetal,
        PQR_FM_WithFillerMetal: headerObj.PQR_FM_WithFillerMetal,
        PQR_FM_FillerProduct: headerObj.PQR_FM_FillerProduct,
        PQR_FM_Inserts: headerObj.PQR_FM_Inserts,
        PQR_FM_FillerFlux: headerObj.PQR_FM_FillerFlux,
        PQR_FM_FillerOthers: headerObj.PQR_FM_FillerOthers,
      };

      let PG1JD = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_JD_JointType: headerObj.PQR_JD_JointType,
        PQR_JD_TubePitch: headerObj.PQR_JD_TubePitch,
        PQR_JD_TubeProj: headerObj.PQR_JD_TubeProj,
        PQR_JD_Pattern: headerObj.PQR_JD_Pattern,
        PQR_JD_GrooveAngle: headerObj.PQR_JD_GrooveAngle,
        PQR_JD_HoleId: headerObj.PQR_JD_HoleId,
        PQR_JD_GrooveDepth: headerObj.PQR_JD_GrooveDepth,
        PQR_JD_WidthLigament: headerObj.PQR_JD_WidthLigament,

        PQR_JD_Notes: headerObj.PQR_JD_Notes,
      };

      let PG1PWHT = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        CheckboxPostWHT: headerObj.CheckboxPostWHT,
        PQR_PWHeatTre_Temperature: headerObj.PQR_PWHeatTre_Temperature,
        PQR_PWHeatTre_Time: headerObj.PQR_PWHeatTre_Time,
        PQR_PWHeatTre_Type: headerObj.PQR_PWHeatTre_Type,
        PQR_PWHeatTre_Heating_Rate: headerObj.PQR_PWHeatTre_Heating_Rate,
        PQR_PWHeatTre_Cooling_Rate: headerObj.PQR_PWHeatTre_Cooling_Rate,
        PQR_PWHeatTre_Notes: headerObj.PQR_PWHeatTre_Notes,

      };

      let CERTI = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        PQR_Certification_ConductedBy: headerObj.PQR_Certification_ConductedBy,
        Certification: headerObj.Certification,
        WPSH_Status: Status.StatusTempSaved,
        WPSH_Approval_Status: Status.StatusTempSaved,
      };

      let Lab_refno = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,
        CertificationLabRef: headerObj.CertificationLabRef,
      };

      if (
        checkwpsdata !== undefined ||
        checkwpsdata !== "" ||
        checkwpsdata !== null
      ) {
        headerObj.WPS_Key = checkwpsdata?.SK;
      }

      headerObj.PQR_Last_UpdatedBy = username;

      headerObj.WPSH_Status = approvalstatus;


      let WPSH_PQR_Process = "";
      let WPSH_PQR_Type = "";

      detailObj.wld_WPSType = headerObj?.wld_WPSType;
      detailObj.PQR_RecordNo = headerObj?.PQR_RecordNo;

      detailObj.PK = headerObj?.wld_WPSType + "#" + headerObj?.PQR_RecordNo;

      WPSH_PQR_Process += detailObj?.PQR_Process;
      WPSH_PQR_Type += detailObj?.WPSD_FM_SFA;

      headerObj.WPSH_PQR_Process = WPSH_PQR_Process;
      headerObj.WPSH_PQR_Type = WPSH_PQR_Type;

      detailObj.wld_WPSType = headerObj?.wld_WPSType;

      detailObj.SK =
        headerObj?.WPSH_PQR_Process + "#" + headerObj?.WPSH_PQR_Type;
      detailObj.showreport = true;

      let PG1Add = {
        Wld_createdon_year: headerObj.Wld_createdon_year,
        wld_WPSType: headerObj.wld_WPSType,
        PQR_RecordNo: headerObj.PQR_RecordNo,

        WPSH_PQR_Process: detailObj?.PQR_Process,
        WPSH_PQR_Type: detailObj?.WPSD_FM_SFA,
        WPSH_Status: headerObj.WPSH_Status,
        Pdf_images: headerObj?.Pdf_images,
        wld_pdf_image: headerObj?.wld_pdf_image,
        CheckboxPostWHT: headerObj?.CheckboxPostWHT,
      };

      const postAdd = [PG1Add];
      let postUpdate = [PG1Update, PG1Images, PG1BM, PG1JD, PG1PWHT, CERTI, Lab_refno];

      // Add test data for copy action
      if (action === Action.ActionCopy) {
        const testObjects = createPQRTestDataObjects(headerObj);
        postUpdate = [...postUpdate, ...Object.values(testObjects)];
      }
      console.log("PGUPDATE", postUpdate)
      await AddUpdatePQRHeader(postAdd, postUpdate, action, setaction)
        .catch((err) => {
          result = MessageTypes.Fail
        })
        .then(async (r) => {
          await AddNewDetail(detailObj)
            .catch((err) => {
              result = MessageTypes.Fail
            })
            .then((r) => {
              console.log("Detail error", r)
              if (r != undefined && r.data != undefined && r.data.message == MessageTypes.SpecialCharacters)
                result = MessageTypes.SpecialCharacters
            });

          try {
            if (r == MessageTypes.SpecialCharacters)
              result = MessageTypes.SpecialCharacters
            await handleImageUploads();
          } catch (error) {
            console.log("Imgae upload failed")
          }
        });

      setaction(Action.ActionEdit)
      return result;
    };


    const commonFetch = createCommonFetchUtilities({

      getPNOActive,
      getActiveFno,
      getActiveAno,
      getActiveSfa
    });

    useEffect(() => {
      commonFetch.fetchAllWeldingData({

        setPNoActive,
        setFnoActive,
        setAnoActive,
        setSfaActive
      });
    }, []);


    const handleImageUploads = async () => {
      try {
        for (const mapping of TubesheetFileMappings) {
          const { profile, imageKey, setPreviewFn } = mapping;
          if (imageKey[0] != "" && imageKey[0] != undefined && profile != "") {
            const result = await getPresignedURL(folderPQR, imageKey[0]);
            const posturl = result.url;
            setPreviewFn(posturl);
            await axios.put(posturl, profile);
          }
        }
      } catch (error) {
        console.error("Error uploading images:", error);
        throw error;
      }
    };

    const fetchImagestube = async (item, setPreviewFn) => {
      fetchImagePreview(folderPQR, item, setPreviewFn)

    };


    useEffect(() => {
      TubesheetFileMappings.forEach(({ imageKey, setPreviewFn, previewFn }) => {
        if (action === Action.ActionEdit || action === Action.ActionCopy) {
          if (imageKey[0] !== "" && imageKey[0] !== undefined && !previewFn) {
            fetchImagestube(imageKey[0], setPreviewFn);
          }
        }
      });
    }, [headerObj.Pdf_images, previewUrl1, previewUrl2, previewUrl3]);

    const fileInputRef = useRef(null);

    const handleSubmit = () => handlePQRGeneralSubmit(validate, handleAdd, setLoading, Status.StatusTempSaved);

    const handleSubmitTemp = () => handlePQRGeneralSubmitTemp(isEdited, validateTemp, handleAdd, setLoading, setIsEdited, headerObj?.WPSH_Status);

    useImperativeHandle(ref, () => ({
      funcOnNext: async () => {
        let res = false;
        res = await handleSubmit();
        return res;
      },

      funcOnNextTemp: async () => {
        let res = false;
        res = await handleSubmitTemp();
        return res;
      },
    }));

    const handleFile1 = (file, index, e) => {
      if (validateFile(file)) {
        if (TubesheetFileMappings[index]) {
          const { setPreviewFn, setImage } = TubesheetFileMappings[index];
          setPreviewFn(URL.createObjectURL(file));
          setImage(file);
          const imageKeys = ["tube_Hole_ligament", "tube_Hole", "tube_Weld_Joint"];
          setheaderObj((prev) => {
            const updatedImages = [...prev.Pdf_images];
            updatedImages[index] = { [imageKeys[index]]: [file.name] };
            return { ...prev, Pdf_images: updatedImages };
          });
        }
      }
    };




    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <Row style={{ padding: "20px 60px" }} className="PQR-Page-row-padding">
          <Row className="mb-2">
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="PQR_RecordNo"
                  type="text"
                  maxLength={12}
                  readOnly={isReadonly}
                  status={error.PQR_RecordNo.status}
                  value={headerObj?.PQR_RecordNo}
                  disabled={action == Action.ActionEdit}
                  onChange={(e) => {
                    handleChange(e)
                    if (action == Action.ActionCopy) {
                      setIsDisabled(false)
                    }

                  }}
                  setError={setError}
                  allowlistfunction={SquareBracketNotAllowed}
                   allowcharacters="-"
                 customMessage="Special Characters # % + $ ' < > = &; not allowed"
                  error={error}
                  label="PQR Record No."
                  message={error.PQR_RecordNo.message}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <DateInput
                divClass="T-input w-100"
                label="Date"
                className="groove_datecolor"
                name="PQR_Date"
                todayDate={todayDate}
                maxDate={maxDate}
                obj={headerObj}
                setobj={setheaderObj}
                setError={setError}
                status={error.PQR_Date.status}
                message={error.PQR_Date.message}
                disabled={isDisabled}
              />
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="PQR_Qualificationcode"
                  type="text"
                  maxLength={20}
                  readOnly={isReadonly}
                  status={error.PQR_Qualificationcode.status}
                  value={headerObj?.PQR_Qualificationcode}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="Qualification Code"
                  message={error.PQR_Qualificationcode.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="PQR_pWPSNo"
                  type="text"
                  maxLength={25}
                  status={error.PQR_pWPSNo.status}
                  value={headerObj?.PQR_pWPSNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={SquareBracketNotAllowed}
                  allowcharacters="+-/"
                  customMessage="Special Characters # %  $ ' < > = &; not allowed"
                  label="pWPSNo(optional)"
                  message={error.PQR_pWPSNo.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="PQR_WPS_ReviNo"
                  type="text"
                  maxLength={2}
                  readOnly={isReadonly}
                  status={error.PQR_WPS_ReviNo.status}
                  value={headerObj?.PQR_WPS_ReviNo}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  label="WPS Revision No."
                  message={error.PQR_WPS_ReviNo.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <DateInput
                divClass="T-input w-100"
                label="Last Update Date"
                className="groove_datecolor"
                name="PQR_LastUpdate_Date"
                todayDate={todayDate}
                maxDate={maxDate}
                obj={headerObj}
                setobj={setheaderObj}
                setError={setError}
                status={error.PQR_LastUpdate_Date.status}
                message={error.PQR_LastUpdate_Date.message}
                disabled={isDisabled}
              />
            </Col>
            <Col md={3}>
              <Form.Group>
                <SingleInput
                  name="PQR_Last_UpdatedBy"
                  type="text"
                  maxLength={20}
                  status={error.PQR_Last_UpdatedBy.status}
                  value={headerObj?.PQR_Last_UpdatedBy}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  readOnly={isReadonly}
                  label="Last Updated By"
                  message={error.PQR_Last_UpdatedBy.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3}>
              <DateInput
                divClass="T-input w-100"
                label="Last Weld Date"
                className="groove_datecolor"
                name="PQR_Last_WeldDate"
                todayDate={todayDate}
                maxDate={maxDate}
                obj={headerObj}
                setobj={setheaderObj}
                setError={setError}
                status={error.PQR_Last_WeldDate.status}
                message={error.PQR_Last_WeldDate.message}
                disabled={isDisabled}
              />
            </Col>
            <Col md={3}>
              <Form.Group>
                <General_Single_Input_select
                  name="PQR_CompanyName"
                  type="text"
                  readOnly={isReadonly}
                  status={error.PQR_Address.status}
                  value={headerObj?.PQR_CompanyName}
                  handleSelectChange={handleChange}
                  label="Company Name"
                  message={error.PQR_Address.message}
                  array={Company_Name}
                  disabled={isDisabled}
                ></General_Single_Input_select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <General_Single_Input_select
                  name="PQR_Address"
                  type="text"
                  maxLength={20}
                  readOnly={isReadonly}
                  status={error.PQR_Address.status}
                  value={headerObj?.PQR_Address}
                  handleSelectChange={handleChange}
                  label="Address"
                  message={error.PQR_Address.message}
                  array={PlantLocation}
                  disabled={isDisabled}
                ></General_Single_Input_select>
              </Form.Group>
            </Col>
          </Row>
        </Row>

        <Row style={{ background: "white", padding: "20px 60px" }}>
          <Row className="mb-1">
            <Col md={12}>
              <p className="WPS-blue-text " style={{ position: "relative", top: "10px" }}>BASE METALS ( QW-403) </p>

              <BaseMetalTable_PQRTube
                headerObj={headerObj}
                setheaderObj={setheaderObj}
                error={error}
                isReadonly={isReadonly}
                isDisabled={isDisabled}
                handleChange={handleChange}
                setError={setError}
                PNoActive={PNoActive}
                blyestyle={blyestyle}
                errorstyle={errorstyle}
                disabled={isDisabled}
              ></BaseMetalTable_PQRTube>
            </Col>
          </Row>
        </Row>

        <Row style={{ padding: "20px 60px" }} className="PQR-Page-row-padding" >
          <span className="WPS-blue-text" >Joint Detail</span>
          <Row className="mb-4" style={{ opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }}>
            <Col>
              <div className="T-input w-100">
                <input
                  type="text"
                  id="PQR_JD_JointType"
                  name="PQR_JD_JointType"
                  value={pqrJointType[0].value}
                  readOnly
                  placeholder=" "
                  disabled={isDisabled}
                />
                <Form.Label htmlFor="PQR_JD_JointType">Joint Type</Form.Label>
              </div>
            </Col>

            <Col>
              <SingleInput
                name="PQR_JD_TubePitch"
                type="text"
                maxLength={20}
                status={error.PQR_JD_TubePitch.status}
                value={headerObj?.PQR_JD_TubePitch}
                onChange={handleChange}
                setError={setError}
                error={error}
                allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinus}
                readOnly={isReadonly}
                label="Tube Pitch"
                message={error.PQR_JD_TubePitch.message}
                disabled={isDisabled}
              ></SingleInput>

            </Col>
            <Col>
              <SingleInput
                name="PQR_JD_TubeProj"
                type="text"
                maxLength={20}
                status={error.PQR_JD_TubeProj.status}
                value={headerObj?.PQR_JD_TubeProj}
                onChange={handleChange}
                setError={setError}
                error={error}
                readOnly={isReadonly}
                allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinus}
                label="Tube Projection"
                message={error.PQR_JD_TubeProj.message}
                disabled={isDisabled}
              ></SingleInput>

            </Col>
            <Col>
              <SingleInput
                name="PQR_JD_Pattern"
                type="text"
                maxLength={20}
                status={error.PQR_JD_Pattern.status}
                value={headerObj?.PQR_JD_Pattern}
                onChange={handleChange}
                setError={setError}
                error={error}
                allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinus}
                readOnly={isReadonly}
                label="Pattern"
                message={error.PQR_JD_Pattern.message}
                disabled={isDisabled}
              ></SingleInput>

            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={3}>
              <SingleInput
                name="PQR_JD_HoleId"
                type="text"
                maxLength={20}
                status={error.PQR_JD_HoleId.status}
                value={headerObj?.PQR_JD_HoleId}
                onChange={handleChange}
                setError={setError}
                error={error}
                allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinus}
                readOnly={isReadonly}
                label="Hole ID(mm)"
                message={error.PQR_JD_HoleId.message}
                disabled={isDisabled}
              ></SingleInput>

            </Col>
            <Col md={3}>
              <SingleInput
                name="PQR_JD_GrooveDepth"
                type="text"
                maxLength={20}
                status={error.PQR_JD_GrooveDepth.status}
                value={headerObj?.PQR_JD_GrooveDepth}
                onChange={handleChange}
                setError={setError}
                error={error}
                allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinus}
                readOnly={isReadonly}
                label="Groove Depth(mm)"
                message={error.PQR_JD_GrooveDepth.message}
                disabled={isDisabled}
              ></SingleInput>

            </Col>
            <Col md={3}>
              <SingleInput
                name="PQR_JD_WidthLigament"
                type="text"
                maxLength={20}
                status={error.PQR_JD_WidthLigament.status}
                value={headerObj?.PQR_JD_WidthLigament}
                onChange={handleChange}
                setError={setError}
                error={error}
                 allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinus}
                readOnly={isReadonly}
                label="Width of the Ligament(mm)"
                message={error.PQR_JD_WidthLigament.message}
                disabled={isDisabled}
              ></SingleInput>

            </Col>
            <Col md={3}>
              <SingleInput
                name="PQR_JD_GrooveAngle"
                type="text"
                maxLength={20}
                status={error.PQR_JD_GrooveAngle.status}
                value={headerObj?.PQR_JD_GrooveAngle}
                onChange={handleChange}
                setError={setError}
                error={error}
                 allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinusDegree}
                readOnly={isReadonly}
                label="Groove Angle(°)/Radius(mm)"
                message={error.PQR_JD_GrooveAngle.message}
                disabled={isDisabled}
              ></SingleInput>
            </Col>
          </Row>
          <Row className="mb-4" style={{ position: "relative", bottom: "7px" }}>

            <Col md={12}>
              <SingleInput
                name="PQR_JD_Notes"
                type="text"
                maxLength={100}
                status={error.PQR_JD_Notes.status}
                value={headerObj?.PQR_JD_Notes}
                onChange={handleChange}
                setError={setError}
                error={error}
                allowlistfunction={isAlphanumericAllSpecialCharactersDashPlusMinusDegree}
                readOnly={isReadonly}
                label="Notes"
                message={error.PQR_JD_Notes.message}
                disabled={isDisabled}
              ></SingleInput>

            </Col>
          </Row>
        </Row>

        <Row style={{ padding: "20px 60px", position: "relative", bottom: "50px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }} className="PQR-Page-row-padding">
          <div style={{ display: "flex", position: "relative", top: "10px", paddingLeft: "0" }}>
            <span className="WPS-blue-text col-md-4">Tube Hole Ligament Detail</span>

            <span className="WPS-blue-text col-md-4">Tube Hole Detail</span>

            <span className="WPS-blue-text col-md-4"> Tube to Tubesheet Weld Joint Detail </span>
          </div>

          <ImageArray3
            setPreviewUrl1={setPreviewUrl1}
            setPreviewUrl2={setPreviewUrl2}
            setPreviewUrl3={setPreviewUrl3}
            previewUrl1={previewUrl1}
            previewUrl2={previewUrl2}
            previewUrl3={previewUrl3}
            headerObj={headerObj}
            setheaderObj={setheaderObj}
            name="fileInput"
            name1="fileInput1"
            name2="fileInput2"
            name3="fileInput3"
            type="file"
            accept="image/*"
            fileInputRef={fileInputRef}
            readOnly={Readonly}
            disabled={isDisabled}
            handleFile={handleFile1}
          ></ImageArray3>

          <Col
            md={12}
            style={{ position: "relative", top: "12px", right: "10px" }}
          >
            <div className="T-input w-100">
              <textarea
                type="text"
                name="PQR_Image_Notes"
                style={{ height: "100px" }}
                id="PQR_Image_Notes"
                readOnly={isReadonly}
                maxLength={90}
                placeholder=" "
                className={
                  error.PQR_Image_Notes.status
                    ? "T-input placeHolderInput inputText text-field-with-error"
                    : "T-input placeHolderInput inputText"
                }
                value={headerObj?.PQR_Image_Notes}
                onChange={handleChange}
                onInput={(e) => {
                  let error = isAlphanumericAllSpecialCharacters(
                    e.target.value
                  );
                  setError((prevState) => ({
                    ...prevState,
                    PQR_Image_Notes: error,
                  }));
                }}
              />
              <Form.Label htmlFor="WPQ_Page2_Notes">Notes</Form.Label>
            </div>
            <div className="required-text1">
              {error.PQR_Image_Notes.status && (
                <Form.Text className="text-danger">
                  {error.PQR_Image_Notes.message}
                </Form.Text>
              )}
            </div>
          </Col>
        </Row>

        <Row style={{ padding: "20px 60px", position: "relative", bottom: "55px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }}>
          <Col md={12}>
            <p className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>Filler Metals (QW-404)</p>
            <PQR_Filler_metals
              headerObj={headerObj}
              detailObj={detailObj}
              disabled={isDisabled}
              error={error}
              readOnly={Readonly}
              handleChangedetailsarray={handleChangedetailsarray}
              handleChangeFillerMetal={handleChangeFillerMetal}
              setError={setError}
              setdetailObj={setdetailObj}
              SfaActive={SfaActive}
              AnoActive={AnoActive}
              FnoActive={FnoActive}
              classError={classError}
              setClassError={setClassError}
              chemicalAnaError={chemicalAnaError}
              setChemicalAnaError={setChemicalAnaError}
              isOverlay={isOverlay}
              setOverlay={setOverlay}
              Grooveclass={Grooveclass}
              setoverlayclass={setoverlayclass}
              overlaytext={overlaytext}
              action={action}
              setaction={setaction}
            ></PQR_Filler_metals>
            <Row className="mb-2">
              <Col md={6}>
                <SingleInput
                  name="PQR_FM_PreFillerMetal"
                  type="text"
                  maxLength={25}
                  status={error.PQR_FM_PreFillerMetal?.status}
                  value={headerObj?.PQR_FM_PreFillerMetal}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAlphanumericWithDashSlashPlus}
                  label="Preplaced Filler Metal"
                  message={error.PQR_FM_PreFillerMetal?.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Col>
              <Col md={6}>
                <SingleInput
                  name="PQR_FM_WithFillerMetal"
                  type="text"
                  maxLength={25}
                  status={error.PQR_FM_WithFillerMetal?.status}
                  value={headerObj?.PQR_FM_WithFillerMetal}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAlphanumericWithDashSlashPlus}
                  label="With/Without Filler Metal"
                  message={error.PQR_FM_WithFillerMetal?.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md={6}>
                <SingleInput
                  name="PQR_FM_FillerProduct"
                  type="text"
                  maxLength={25}
                  status={error.PQR_FM_FillerProduct?.status}
                  value={headerObj?.PQR_FM_FillerProduct}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAlphanumericWithDashSlashPlus}
                  label="Filler Metal Product Form"
                  message={error.PQR_FM_FillerProduct?.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Col>
              <Col md={6}>
                <SingleInput
                  name="PQR_FM_Inserts"
                  type="text"
                  maxLength={25}
                  status={error.PQR_FM_Inserts?.status}
                  value={headerObj?.PQR_FM_Inserts}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAlphanumericWithDashSlashPlus}
                  label="Inserts"
                  message={error.PQR_FM_Inserts?.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md={6}>
                <SingleInput
                  name="PQR_FM_FillerFlux"
                  type="text"
                  maxLength={25}
                  status={error.PQR_FM_FillerFlux?.status}
                  value={headerObj?.PQR_FM_FillerFlux}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAlphanumericWithDashSlashPlus}
                  label="Filler Metals - Flux"
                  message={error.PQR_FM_FillerFlux?.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Col>
              <Col md={6}>
                <SingleInput
                  name="PQR_FM_FillerOthers"
                  type="text"
                  maxLength={25}
                  status={error.PQR_FM_FillerOthers?.status}
                  value={headerObj?.PQR_FM_FillerOthers}
                  onChange={handleChange}
                  setError={setError}
                  error={error}
                  allowlistfunction={isAlphanumericWithDashSlashPlus}
                  label="Filler Metals - Others"
                  message={error.PQR_FM_FillerOthers?.message}
                  disabled={isDisabled}
                ></SingleInput>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="mb-4" style={{ padding: "0px 60px", position: "relative", bottom: "65px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }}>
          <span className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>Welding Procedure</span>
          <Col>
            <Table
              bordered
              responsive="sm"
              className="text-center tube-col-widths"
              style={{ position: "relative", bottom: "10px" }}
            >
              <tbody>
                <PQR_Process_Grid_InputProcess
                  detailObj={detailObj}
                  readOnly={isReadonly}
                  disabled={isDisabled}
                  ColumnHeader="Welding Process & Type"
                  type="text"
                  name="PQRD_WP_WeldingProcess"
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_Process_Grid_InputProcess>

                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  ColumnHeader="Minimum Preheat Temp"
                  Columndimension="°C"
                  width1={275}
                  status={error.PQRD_WP_MinimumPreheatTemp.status}
                  message={error.PQRD_WP_MinimumPreheatTemp.message}
                  type="text"
                  name="PQRD_WP_MinimumPreheatTemp"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersPlusMinusDegree(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_MinimumPreheatTemp: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>

                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  ColumnHeader=" Maximum Interpass Temp"
                  Columndimension="°C"
                  status={error.PQRD_WP_MaximumInterpassTemp.status}
                  message={error.PQRD_WP_MaximumInterpassTemp.message}
                  type="text"
                  name="PQRD_WP_MaximumInterpassTemp"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersPlusMinusDegree(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_MaximumInterpassTemp: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>

                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  ColumnHeader="Post Heating/DHT"
                  status={error.PQRD_WP_PostHeating.status}
                  message={error.PQRD_WP_PostHeating.message}
                  type="text"
                  name="PQRD_WP_PostHeating"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersPlusMinusDegree(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_PostHeating: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>

                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  ColumnHeader="Tungsten Type and Size"
                  Columndimension="mm"
                  status={error.PQRD_WP_TungstenType.status}
                  message={error.PQRD_WP_TungstenType.message}
                  type="text"
                  name="PQRD_WP_TungstenType"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersPlusMinusDegree(
                      e.target.value
                    );
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_TungstenType: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>
                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  ColumnHeader="Welding Position"
                  status={error.PQRD_WP_WeldPosition.status}
                  message={error.PQRD_WP_WeldPosition.message}
                  type="text"
                  name="PQRD_WP_WeldPosition"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersPlusMinusDegree(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_WeldPosition: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>
                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={20}
                  width1={275}
                  ColumnHeader="Progression"
                  status={error.PQRD_WP_WeldProgression.status}
                  message={error.PQRD_WP_WeldProgression.message}
                  type="text"
                  name="PQRD_WP_WeldProgression"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharacters(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_WeldProgression: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>
                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  ColumnHeader="No of Passes"
                  status={error.PQRD_WP_NoofPasses.status}
                  message={error.PQRD_WP_NoofPasses.message}
                  type="text"
                  name="PQRD_WP_NoofPasses"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersPlusMinusDegree(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_NoofPasses: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>
              </tbody>
            </Table>

            <Table
              bordered
              responsive="sm"
              className="text-center tube-col-widths"
              style={{ position: "relative", bottom: "30px" }}
            >
              <tbody>
                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="Layer Number"
                  status={error.PQRD_WP_LayerNo[0]?.Value_A[0]?.status}
                  message={error.PQRD_WP_LayerNo[0]?.Value_A[0]?.message}
                  status1={error.PQRD_WP_LayerNo[1]?.Value_B[0]?.status}
                  message1={error.PQRD_WP_LayerNo[1]?.Value_B[0]?.message}
                  status2={error.PQRD_WP_LayerNo[2]?.Value_C?.[0]?.status}
                  message2={error.PQRD_WP_LayerNo[2]?.Value_C?.[0]?.message}
                  type="text"
                  name="PQRD_WP_LayerNo"
                  setError={setError}
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  validatorFn={isAlphanumericWithDashSlashPlusAmpersand}
                ></WPQ_PQR_Process_Grid_Input2_tube>

                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="Filler Metal Size(Ø)"
                  Columndimension="mm"
                  status={error.PQRD_WP_FillerMetalSize[0]?.Value_A[0]?.status}
                  message={
                    error.PQRD_WP_FillerMetalSize[0]?.Value_A[0]?.message
                  }
                  status1={error.PQRD_WP_FillerMetalSize[1]?.Value_B[0]?.status}
                  message1={
                    error.PQRD_WP_FillerMetalSize[1]?.Value_B[0]?.message
                  }
                  status2={error.PQRD_WP_FillerMetalSize[2]?.Value_C[0]?.status}
                  message2={
                    error.PQRD_WP_FillerMetalSize[2]?.Value_C[0]?.message
                  }
                  type="text"
                  setError={setError}
                  name="PQRD_WP_FillerMetalSize"
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  validatorFn={isAlphanumericWithDiameterDashSlash}
                ></WPQ_PQR_Process_Grid_Input2_tube>

                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="Amperes Amps"
                  status={error.PQRD_WP_Amperes[0]?.Value_A[0]?.status}
                  message={error.PQRD_WP_Amperes[0]?.Value_A[0]?.message}
                  status1={error.PQRD_WP_Amperes[1]?.Value_B[0]?.status}
                  message1={error.PQRD_WP_Amperes[1]?.Value_B[0]?.message}
                  status2={error.PQRD_WP_Amperes[2]?.Value_C[0]?.status}
                  message2={error.PQRD_WP_Amperes[2]?.Value_C[0]?.message}
                  type="text"
                  name="PQRD_WP_Amperes"
                  setError={setError}
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  fillerMetalField="PQRD_WP_FillerMetalSize"
                ></WPQ_PQR_Process_Grid_Input2_tube>

                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="DC Pulsing Current"
                  Columndimension="Amps"
                  status={error.PQRD_WP_DC_Pulsing_current[0]?.Value_A[0]?.status}
                  message={
                    error.PQRD_WP_DC_Pulsing_current[0]?.Value_A[0]?.message
                  }
                  status1={
                    error.PQRD_WP_DC_Pulsing_current[1]?.Value_B[0]?.status
                  }
                  message1={
                    error.PQRD_WP_DC_Pulsing_current[1]?.Value_B[0]?.message
                  }
                  status2={error.PQRD_WP_DC_Pulsing_current[2]?.Value_C[0]?.status}
                  message2={
                    error.PQRD_WP_DC_Pulsing_current[2]?.Value_C[0]?.message
                  }
                  type="text"
                  name="PQRD_WP_DC_Pulsing_current"
                  setError={setError}
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  fillerMetalField="PQRD_WP_FillerMetalSize"
                ></WPQ_PQR_Process_Grid_Input2_tube>
                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="DC Pulsing Current - Others"
                  Columndimension="Amps"
                  status={error.PQRD_WP_DC_Pulsing_current_Others[0]?.Value_A[0]?.status}
                  message={
                    error.PQRD_WP_DC_Pulsing_current_Others[0]?.Value_A[0]?.message
                  }
                  status1={
                    error.PQRD_WP_DC_Pulsing_current_Others[1]?.Value_B[0]?.status
                  }
                  message1={
                    error.PQRD_WP_DC_Pulsing_current_Others[1]?.Value_B[0]?.message
                  }
                  status2={error.PQRD_WP_DC_Pulsing_current_Others[2]?.Value_C[0]?.status}
                  message2={
                    error.PQRD_WP_DC_Pulsing_current_Others[2]?.Value_C[0]?.message
                  }
                  type="text"
                  error={error}
                  name="PQRD_WP_DC_Pulsing_current_Others"
                  setError={setError}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  fillerMetalField="PQRD_WP_FillerMetalSize"
                ></WPQ_PQR_Process_Grid_Input2_tube>

                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="Voltage Volts"
                  Columndimension="Kj/mm"
                  status={error.PQRD_WP_Volatage_Volts[0]?.Value_A[0]?.status}
                  message={error.PQRD_WP_Volatage_Volts[0]?.Value_A[0]?.message}
                  status1={error.PQRD_WP_Volatage_Volts[1]?.Value_B[0]?.status}
                  message1={error.PQRD_WP_Volatage_Volts[1]?.Value_B[0]?.message}
                  status2={error.PQRD_WP_Volatage_Volts[2]?.Value_C[0]?.status}
                  message2={error.PQRD_WP_Volatage_Volts[2]?.Value_C[0]?.message}
                  type="text"
                  name="PQRD_WP_Volatage_Volts"
                  setError={setError}
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  fillerMetalField="PQRD_WP_FillerMetalSize"
                ></WPQ_PQR_Process_Grid_Input2_tube>

                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="Travel Speed"
                  Columndimension="mm/min"
                  status={error.PQRD_WP_Travel_Speed[0]?.Value_A[0]?.status}
                  message={error.PQRD_WP_Travel_Speed[0]?.Value_A[0]?.message}
                  status1={error.PQRD_WP_Travel_Speed[1]?.Value_B[0]?.status}
                  message1={error.PQRD_WP_Travel_Speed[1]?.Value_B[0]?.message}
                  status2={error.PQRD_WP_Travel_Speed[2]?.Value_C[0]?.status}
                  message2={error.PQRD_WP_Travel_Speed[2]?.Value_C[0]?.message}
                  type="text"
                  name="PQRD_WP_Travel_Speed"
                  setError={setError}
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  fillerMetalField="PQRD_WP_FillerMetalSize"
                ></WPQ_PQR_Process_Grid_Input2_tube>

                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="Heat Input"
                  Columndimension="Kj/mm"
                  status={error.PQRD_WP_Heat_Input[0]?.Value_A[0]?.status}
                  message={error.PQRD_WP_Heat_Input[0]?.Value_A[0]?.message}
                  status1={error.PQRD_WP_Heat_Input[1]?.Value_B[0]?.status}
                  message1={error.PQRD_WP_Heat_Input[1]?.Value_B[0]?.message}
                  status2={error.PQRD_WP_Heat_Input[2]?.Value_C[0]?.status}
                  message2={error.PQRD_WP_Heat_Input[2]?.Value_C[0]?.message}
                  type="text"
                  name="PQRD_WP_Heat_Input"
                  setError={setError}
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                  handle_2Input_ChangeC={handle_2Input_ChangeC}
                  fillerMetalField="PQRD_WP_FillerMetalSize"
                ></WPQ_PQR_Process_Grid_Input2_tube>

                <WPQ_PQR_Process_Grid_Input2_tube
                  detailObj={detailObj}
                  maxLength={20}
                  ColumnHeader="Polarity or Current type"
                  status={error.PQRD_WP_PolarityOrCurrent[0]?.Value_A[0]?.status}
                  message={
                    error.PQRD_WP_PolarityOrCurrent[0]?.Value_A[0]?.message
                  }
                  status1={error.PQRD_WP_PolarityOrCurrent[1]?.Value_B[0]?.status}
                  message1={
                    error.PQRD_WP_PolarityOrCurrent[1]?.Value_B[0]?.message
                  }
                  type="text"
                  name="PQRD_WP_PolarityOrCurrent"
                  setError={setError}
                  error={error}
                  handle_2Input_ChangeA={handle_2Input_ChangeA}
                  handle_2Input_ChangeB={handle_2Input_ChangeB}
                ></WPQ_PQR_Process_Grid_Input2_tube>
              </tbody>
            </Table>

            <Table
              bordered
              responsive="sm"
              className="text-center tube-col-widths"
              style={{ position: "relative", bottom: "50px" }}
            >
              <tbody>
                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  ColumnHeader="Automatic Arc Voltage control"
                  status={error.PQRD_WP_ArcVoltageControl.status}
                  message={error.PQRD_WP_ArcVoltageControl.message}
                  type="text"
                  name="PQRD_WP_ArcVoltageControl"
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersAmpersand(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_ArcVoltageControl: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>

                <PQRProcessGridInput2
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  mainheading="Shielding"
                  ColumnHeader="Gas Type - % comp"
                  ColumnHeader1="Flow Type"
                  Columndimension="I/min"
                  status={
                    error.PQRD_WP_ShieldingGasType.status ||
                    error.PQRD_WP_ShieldingFlowRate.status
                  }
                  message={
                    error.PQRD_WP_ShieldingGasType.message ||
                    error.PQRD_WP_ShieldingFlowRate.message
                  }
                  type="text"
                  name="PQRD_WP_ShieldingGasType"
                  name1="PQRD_WP_ShieldingFlowRate"
                  onInput={(e) => {
                    let error =
                      isAlphanumericMinusPlusPercent(
                        e.target.value
                      );
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_ShieldingGasType: error,
                    }));
                  }}
                  onInput1={(e) => {
                    let error =
                      isAlphanumericMinusPlusPercent(
                        e.target.value
                      );
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_ShieldingFlowRate: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQRProcessGridInput2>

                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={50}
                  width1={275}
                  ColumnHeader="Auxiliarygas shield system"
                  status={error.PQRD_WP_Auxiliarygas.status}
                  message={error.PQRD_WP_Auxiliarygas.message}
                  type="text"
                  name="PQRD_WP_Auxiliarygas"
                  onInput={(e) => {
                    let error =
                      isAlphanumericAllSpecialCharacters(
                        e.target.value
                      );
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_Auxiliarygas: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>

                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={60}
                  width1={275}
                  ColumnHeader="Expansion"
                  status={error.PQRD_WP_Expansion.status}
                  message={error.PQRD_WP_Expansion.message}
                  type="text"
                  name="PQRD_WP_Expansion"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_Expansion: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>

                <PQR_TTS_Process_Grid_Input
                  detailObj={detailObj}
                  maxLength={50}
                  width1={275}
                  ColumnHeader="Method of Cleaning"
                  status={error.PQRD_WP_MethodofCleaning.status}
                  message={error.PQRD_WP_MethodofCleaning.message}
                  type="text"
                  name="PQRD_WP_MethodofCleaning"
                  onInput={(e) => {
                    let error =
                      isAlphanumericAllSpecialCharacters(
                        e.target.value
                      );
                    setError((prevState) => ({
                      ...prevState,
                      PQRD_WP_MethodofCleaning: error,
                    }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input>
                <PQR_TTS_Process_Grid_Input_2
                  detailObj={detailObj}
                  maxLength={25}
                  width1={275}
                  ColumnHeader="Single/Multi Electrode"
                  status={error.PQRD_WP_SingleMultiElectrode.status}
                  message={error.PQRD_WP_SingleMultiElectrode.message}
                  type="text"
                  name="PQRD_WP_SingleMultiElectrode"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({ ...prevState, PQRD_WP_SingleMultiElectrode: error }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input_2>
                <PQR_TTS_Process_Grid_Input_2
                  detailObj={detailObj}
                  maxLength={25}
                  width1={275}
                  ColumnHeader="Peening"
                  status={error.PQRD_WP_Peening.status}
                  message={error.PQRD_WP_Peening.message}
                  type="text"
                  name="PQRD_WP_Peening"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({ ...prevState, PQRD_WP_Peening: error }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input_2>
                <PQR_TTS_Process_Grid_Input_2
                  detailObj={detailObj}
                  maxLength={25}
                  width1={275}
                  ColumnHeader="Use of Thermal Process"
                  status={error.PQRD_WP_ThermalProcess.status}
                  message={error.PQRD_WP_ThermalProcess.message}
                  type="text"
                  name="PQRD_WP_ThermalProcess"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({ ...prevState, PQRD_WP_ThermalProcess: error }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input_2>
                <PQR_TTS_Process_Grid_Input_2
                  detailObj={detailObj}
                  maxLength={25}
                  width1={275}
                  ColumnHeader="String & Weave"
                  status={error.PQRD_WP_StringWeave.status}
                  message={error.PQRD_WP_StringWeave.message}
                  type="text"
                  name="PQRD_WP_StringWeave"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({ ...prevState, PQRD_WP_StringWeave: error }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input_2>
                <PQR_TTS_Process_Grid_Input_2
                  detailObj={detailObj}
                  maxLength={25}
                  width1={275}
                  ColumnHeader="Oscillation"
                  status={error.PQRD_WP_Oscillation.status}
                  message={error.PQRD_WP_Oscillation.message}
                  type="text"
                  name="PQRD_WP_Oscillation"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({ ...prevState, PQRD_WP_Oscillation: error }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input_2>
                <PQR_TTS_Process_Grid_Input_2
                  detailObj={detailObj}
                  maxLength={25}
                  width1={275}
                  ColumnHeader="Orifice Cup Size in mm"
                  status={error.PQRD_WP_OrificeCupSize.status}
                  message={error.PQRD_WP_OrificeCupSize.message}
                  type="text"
                  name="PQRD_WP_OrificeCupSize"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({ ...prevState, PQRD_WP_OrificeCupSize: error }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input_2>
                <PQR_TTS_Process_Grid_Input_2
                  detailObj={detailObj}
                  maxLength={25}
                  width1={275}
                  ColumnHeader="Closed to Out Chamber"
                  status={error.PQRD_WP_ClosedOutChamber.status}
                  message={error.PQRD_WP_ClosedOutChamber.message}
                  type="text"
                  name="PQRD_WP_ClosedOutChamber"
                  onInput={(e) => {
                    let error = isAlphanumericWithDashSlashPlusAmpersand(e.target.value);
                    setError((prevState) => ({ ...prevState, PQRD_WP_ClosedOutChamber: error }));
                  }}
                  handleChangedetailsarray={handleChangedetailsarray}
                ></PQR_TTS_Process_Grid_Input_2>
              </tbody>
            </Table>
          </Col>
        </Row>

        <Row style={{
          paddingTop: '20px',
          paddingRight: '20px',
          paddingBottom: '20px',
          paddingLeft: '60px'
          , position: "relative", bottom: "85px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto'
        }} className="PQR-Page-row-padding">
          <Row>
            <Row>
              <div className="checkboxproject">
                <input
                  type="checkbox"
                  placeholder=" "
                  id="chkcode"
                  name="CheckboxPostWHT"
                  onChange={(e) => handleCheckboxChange(e, "CheckboxPostWHT", setIsChecked)}
                  checked={(() => {
                    if (headerObj?.CheckboxPostWHT === "No") {
                      return false;
                    }
                    return isChecked;
                  })()}

                />{" "}
                <span className="WPS-blue-text" style={{ position: "relative", left: "5px", bottom: "2px" }}>
                  Post Weld Heat Treatment Tubesheet (QW-407)
                </span>
              </div>
            </Row>
            <Row className="mb-1" style={{ position: "relative", top: "18px" }}>
              <Col className="mb-1" md={3}>
                <SingleInput
                  name="PQR_PWHeatTre_Temperature"
                  type="text"
                  maxLength={15}
                  status={error.PQR_PWHeatTre_Temperature.status}
                  value={headerObj?.PQR_PWHeatTre_Temperature}
                  disabled={headerObj?.CheckboxPostWHT === "No" ? true : fieldPWHT}
                  onChange={handleChange}
                  label="Temperarture(°C)"
                  setError={setError}
                  error={error}
                  allowlistfunction={SquareBracketNotAllowed}
                  allowcharacters="/+°±\-"
                  customMessage="Special Characters # % $ ' < > = & ; not allowed"
                  message={error.PQR_PWHeatTre_Temperature.message}
                ></SingleInput>
              </Col>

              <Col className="mb-1" md={3}>
                <SingleInput
                  name="PQR_PWHeatTre_Time"
                  type="text"
                  maxLength={20}
                  status={error.PQR_PWHeatTre_Time.status}
                  value={headerObj?.PQR_PWHeatTre_Time}
                  disabled={headerObj?.CheckboxPostWHT === "No" ? true : fieldPWHT}
                  onChange={handleChange}
                  label="Time (Minutes)"
                  message={error.PQR_PWHeatTre_Time.message}
                  setError={setError}
                  error={error}
                ></SingleInput>
              </Col>

              <Col className="mb-1" md={3}>
                <SingleInput
                  name="PQR_PWHeatTre_Type"
                  type="text"
                  maxLength={15}
                  status={error.PQR_PWHeatTre_Type.status}
                  value={headerObj?.PQR_PWHeatTre_Type}
                  disabled={headerObj?.CheckboxPostWHT === "No" ? true : fieldPWHT}
                  onChange={handleChange}
                  label="Type"
                  message={error.PQR_PWHeatTre_Type.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={SquareBracketNotAllowed}
                  allowcharacters="/+°±\-"
                  customMessage="Special Characters # % $ ' < > = & ; not allowed"
                ></SingleInput>
              </Col>
              <Col className="mb-1" md={3}>
                <SingleInput
                  name="PQR_PWHeatTre_Heating_Rate"
                  type="text"
                  maxLength={15}
                  status={error.PQR_PWHeatTre_Heating_Rate.status}
                  value={headerObj?.PQR_PWHeatTre_Heating_Rate}
                  disabled={headerObj?.CheckboxPostWHT === "No" ? true : fieldPWHT}
                  onChange={handleChange}
                  label="HeatingRate"
                  message={error.PQR_PWHeatTre_Heating_Rate.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={SquareBracketNotAllowed}
                  allowcharacters="/+°±\-"
                  customMessage="Special Characters # % $ ' < > = & ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col className="mb-1" md={3}>
                <br></br>
                <SingleInput
                  name="PQR_PWHeatTre_Cooling_Rate"
                  type="text"
                  maxLength={15}
                  disabled={headerObj?.CheckboxPostWHT === "No" ? true : fieldPWHT}
                  status={error.PQR_PWHeatTre_Cooling_Rate.status}
                  value={headerObj?.PQR_PWHeatTre_Cooling_Rate}
                  onChange={handleChange}
                  label=" Cooling Rate (C/Hr)"
                  message={error.PQR_PWHeatTre_Cooling_Rate.message}
                  setError={setError}
                  error={error}
                  allowlistfunction={SquareBracketNotAllowed}
                  allowcharacters="/+°±\-"
                  customMessage="Special Characters # % $ ' < > = & ; not allowed"
                ></SingleInput>
              </Col>
            </Row>
            <Row className="mb-1">
              <Col className="mb-1" md={12}>
                <SingleInputTextAreaNotes
                  name="PQR_PWHeatTre_Notes"
                  type="text"
                  style={{ height: "70px", resize: "none" }}
                  maxLength={90}
                  className="textarea-notes"
                  disabled={headerObj?.CheckboxPostWHT === "No" ? true : fieldPWHT}
                  status={error.PQR_PWHeatTre_Notes.status}
                  value={headerObj.PQR_PWHeatTre_Notes ? headerObj.PQR_PWHeatTre_Notes : valueNotes}
                  handleChange={handleChangeNotes}
                  label="Notes"
                  message={error.PQR_PWHeatTre_Notes.message}
                  onInput={(e) => {
                    let error = isAlphanumericAllSpecialCharactersPlusMinusDegree(e.target.value);
                    setError((prevState) => ({
                      ...prevState,
                      PQR_PWHeatTre_Notes: error,
                    }));
                  }}
                ></SingleInputTextAreaNotes>
              </Col>
            </Row>
          </Row>
        </Row>


        <Row style={{ padding: "20px 60px", position: "relative", bottom: "45px", height: "451px", opacity: isDisabled ? 0.5 : 1, pointerEvents: isDisabled ? 'none' : 'auto' }} className="PQR-Page-row-padding">
          <Row className="mb-1" style={{ width: "55%" }}>
            <span className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>Certification</span>
            <PQRPage3TableColumnN
              columns={3}
              width={[160, 140, 130]}
              width1={160}
              width2={140}
              width3={130}
              sessionName={sessionName}
              maxLength={[25, 10, 19]}
              array={Certification}
              setheaderObj={setheaderObj}
              disabled={Certification_Disabled}
              setError={setError}
              numberofrowsdisabled={4}
              allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
              title={["Welder's Name", "ID", "Process"]}
              name={["PQR_Certification_Welder_Name", "PQR_Certification_ID", "PQR_Certification_Process"]}
              status={[error.PQR_Certification_Welder_Name.status, error.PQR_Certification_ID.status, error.PQR_Certification_Process.status]}
              message={[error.PQR_Certification_Welder_Name.message, error.PQR_Certification_ID.message, error.PQR_Certification_Process.message]}
              handleChangetestarray={handleCertificationarray}
            />
            <span style={{ position: "relative", left: "102%", bottom: "46.6%", gap: "5px" }}>
              <Col md={3}>
                <SingleInput
                  disabled={copydata}
                  style={{ width: "500px" }}
                  name="PQR_Certification_ConductedBy"
                  type="text"
                  maxLength={50}
                  status={error.PQR_Certification_ConductedBy.status}
                  value={headerObj?.PQR_Certification_ConductedBy}
                  onChange={handleChange}
                  label="Tests Conducted by"
                  message={error.PQR_Certification_ConductedBy.message}
                  setError={setError}
                  allowlistfunction={isAllowDashedSpecialCharactersPlusMinusPercentAmpersand}
                  error={error}
                ></SingleInput>
              </Col>
              <Col md={3} style={{ width: "500px", position: "relative", bottom: "11px"}}>
                <PQRPage3TableColumnN
                  columns={1}
                  width1={480}
                  width={[480]}
                  sessionName={sessionName}
                  maxLength={[45]}
                  array={CertificationLabRef}
                  setheaderObj={setheaderObj}
                  setError={setError}
                  numberofrowsdisabled={2}
                  title={["Laboratory Ref.Number"]}
                  allowlistfunction={isAlphanumericMinusPlusPercent}
                  name={["PQR_Certification_Lab_RefNo"]}
                  status={[error.PQR_Certification_Lab_RefNo.status]}
                  message={[error.PQR_Certification_Lab_RefNo.message]}
                  handleChangetestarray={handleCertificationLabRef}
                />
              </Col>
            </span>
          </Row>
        </Row>
      </Row>
    );
  }
);

export default PQRTubesheetPage1;
